<template>
    <div class="row">
        <div class="col-3 form-group"
            v-for="scenario in sortedScenarios"
            :key="scenario.Id"
        >
            <slot v-bind:scenario="scenario"></slot>
        </div>
    </div>
</template>

<script>
    import sortScenariosMixin from '../Mixins/sort-scenarios-mixin';
    
    export default {
        name: "scenario-list",
        mixins: [sortScenariosMixin],
        computed: {
            sortedScenarios(){
                return this.sortScenarios(this.scenarios);
            }
        },
        props: {
            scenarios: {
                type: Array,
                required: true
            }
        }
    };
</script>

<style scoped>

</style>
